import React from 'react';
import { Breadcrumb, Panel } from 'rsuite';
import SubscriptionCodeListPage from './subscription-code-list';
import PageHeader from '@/components/PageHeader';

const Page = () => {
  return (
    <Panel
      header={
        <PageHeader title="Subscription Codes">
          <Breadcrumb>
            <Breadcrumb.Item href="/">Home</Breadcrumb.Item>            
            <Breadcrumb.Item>Subscription</Breadcrumb.Item>
            <Breadcrumb.Item active>Codes</Breadcrumb.Item>
          </Breadcrumb>
        </PageHeader>
      }
    >
      <SubscriptionCodeListPage />
    </Panel>
  );
};

export default Page;
